export enum EventTypes {
  CREATED = 'CREATED',
  UPDATED = 'UPDATED',
}
